export function msgbox(ctx) {
    return {
        styles: {
            // LV_MSGBOX_PART_BG
            main: { ...ctx.pretty, text_font: 32 },
            // LV_MSGBOX_PART_BTN_BG — same bg as body, no separator
            items: { bg_color: ctx.SCR, bg_opa: 255, border_width: 0 },
            // LV_MSGBOX_PART_BTN — pill-shaped buttons. Shares the plain btn
            // theme's real PRESSED color change (only reachable state for
            // msgbox buttons — see FIRMWARE-PARITY-AUDIT.md's msgbox section).
            // Mirrors ctx.btnStyle's own pressed override (see shared.js).
            item_buttons: {
                bg_color:     ctx.SCR,
                bg_opa:       255,
                border_color: ctx.btnBorder,
                border_width: 2,
                radius:       999,
                text_color:   ctx.TEXT_DEFAULT,
                text_font:    32,
                states: {
                    pressed: { bg_color: ctx.btnPr, border_color: ctx.BTN_BORDER_CHK, text_color: ctx.TEXT_PR },
                },
            },
        },
    };
}
